import { PatientsContextFactory } from './PatientsContextFactory';

export const patientsContextDependencies = {
  patientsInteractor: PatientsContextFactory.patientsInteractor(),
};
